import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77b8ca8f")

_pushScopeId("data-v-77b8ca8f")
const _hoisted_1 = { class: "h-screen" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 印刷 ")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-gray-500 hidden md:block" }, " ※画像のダウンロードは右クリックの後「名前をつけて保存」をしてください。 ", -1)
const _hoisted_5 = { class: "flex flex-col md:flex-row items-center" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "text-xl" }
const _hoisted_8 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" （最新提出時刻 : ")
const _hoisted_10 = {
  key: 1,
  class: "ml-4"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("） ")
const _hoisted_12 = {
  key: 0,
  class: "w-full mt-4"
}
const _hoisted_13 = { class: "flex items-center mb-2 flex-row" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "text-sm font-medium mx-2" }, "生徒からのコメント", -1)
const _hoisted_15 = { class: "w-full mt-4" }
const _hoisted_16 = {
  key: 0,
  class: "w-full p-3 rounded-md border flex items-center text-yellow-400"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm font-medium" }, "提出された画像がありません", -1)
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = {
  key: 1,
  class: "w-full p-3 rounded-md border-4 border-gray-300 text-sm font-normal text-yellow-300 flex"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "text-gray-500 font-medium" }, " この画像は削除されています ", -1)
const _hoisted_21 = {
  key: 1,
  class: "w-full mt-4"
}
const _hoisted_22 = { class: "mb-2" }
const _hoisted_23 = { class: "text-black" }
const _hoisted_24 = { class: "text-black px-2" }
const _hoisted_25 = {
  key: 0,
  className: "fixed right-0 top-0 print-hidden hidden lg:block w-1/4 z-0 h-full bg-primary-100 border-l-4 border-primary-100 overflow-hidden lg:overscroll-auto"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MSMessagePanel = _resolveComponent("MSMessagePanel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: _ctx.useMessagePanel ? 'lg:w-3/4' : ''
    }, [
      _createVNode("div", {
        class: ["p-4 bg-white print-hidden border-b-4 border-primary-100 fixed w-full", _ctx.useMessagePanel ? 'lg:w-3/4' : '']
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_m_button, {
            class: "mr-4",
            color: "primary-500",
            "hover-color": "primary-600",
            onClick: _ctx.print
          }, {
            default: _withId(() => [
              _createVNode(_component_m_icon, {
                type: "printer",
                class: "mr-2"
              }),
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]),
          _hoisted_4
        ])
      ], 2),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataMaps, (dataMap) => {
        return (_openBlock(), _createBlock("div", {
          id: dataMap.data.uid,
          key: dataMap.data.uid,
          class: "m-4 mt-0 pt-24 print:pt-0 pb-16"
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("h1", _hoisted_7, _toDisplayString(dataMap.threadMasterData?.name), 1),
              (dataMap.studentData)
                ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(dataMap.studentData.name), 1))
                : _createCommentVNode("", true),
              _hoisted_9,
              (
                dataMap.data.posts
                  .filter(p => p.type !== 'text')
                  .sort((a, b) => b.time - a.time)[0]?.time > 0
              )
                ? (_openBlock(), _createBlock("time", _hoisted_10, _toDisplayString(_ctx.toTimeString(
                  dataMap.data.posts
                    .filter(p => p.type !== "text")
                    .sort((a, b) => b.time - a.time)[0]?.time
                )), 1))
                : _createCommentVNode("", true),
              _hoisted_11
            ])
          ]),
          (dataMap.data.posts.find(p => p.type === 'text'))
            ? (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("img", {
                    src: _ctx.icon,
                    alt: "生徒",
                    class: "w-8 h-8 rounded-full"
                  }, null, 8, ["src"]),
                  _hoisted_14
                ]),
                _createVNode("div", {
                  class: ["p-4 bg-gray-100 text-sm rounded whitespace-pre-wrap break-words mr-3 ml-10", {
              'page-break-after-always': _ctx.isLongComment(
                dataMap.data.posts.find(p => p.type === 'text')?.value ?? ''
              )
            }]
                }, _toDisplayString(dataMap.data.posts.find(p => p.type === "text")?.value), 3)
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_15, [
            (
              dataMap.data.posts.filter(n => n.type === 'image').length === 0
            )
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode(_component_m_icon, {
                    type: "warning",
                    size: "6",
                    class: "mr-2"
                  }),
                  _hoisted_17
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(dataMap.data.posts
              .filter(n => n.type === 'image')
              .sort((a, b) => b.time - a.time), (post, uIndex) => {
              return (_openBlock(), _createBlock("div", {
                key: post.url,
                class: "mb-4"
              }, [
                _createVNode("div", _hoisted_18, _toDisplayString(dataMap.studentData?.name) + "【" + _toDisplayString(dataMap.data.posts.filter(n => n.type === "image").length -
                uIndex) + " / " + _toDisplayString(dataMap.data.posts.filter(n => n.type === "image").length) + "】" + _toDisplayString(_ctx.toTimeString(post.time)), 1),
                (!_ctx.imageUrlsRequiringAltDisplay.includes(post.url))
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: post.url,
                      class: "image page-break-after-always",
                      onError: ($event: any) => (_ctx.setAltImage(post.url))
                    }, null, 40, ["src", "onError"]))
                  : _createCommentVNode("", true),
                (_ctx.imageUrlsRequiringAltDisplay.includes(post.url))
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      _createVNode(_component_m_icon, {
                        type: "warning",
                        size: "6",
                        class: "mr-2"
                      }),
                      _hoisted_20
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          (dataMap.data.posts.filter(n => n.type === 'file').length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, _toDisplayString(dataMap.studentData?.name) + "【 画像以外の提出ファイル 】 ", 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(dataMap.data.posts
              .filter(n => n.type === 'file')
              .sort((a, b) => b.time - a.time), (post) => {
                  return (_openBlock(), _createBlock("div", {
                    key: post.url,
                    class: "my-2"
                  }, [
                    _createVNode("a", {
                      href: post.url,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "p-3 rounded-md border flex items-center text-sm font-medium text-primary-500"
                    }, [
                      _createVNode(_component_m_icon, {
                        type: post.contentIconType,
                        width: "0.7",
                        size: "8",
                        class: "mr-2"
                      }, null, 8, ["type"]),
                      _createVNode("span", _hoisted_23, _toDisplayString(post.contentTypeToDisplay) + " (" + _toDisplayString(post.sizeString) + ") ", 1),
                      _createVNode("span", _hoisted_24, _toDisplayString(_ctx.toTimeString(post.time)), 1)
                    ], 8, ["href"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 8, ["id"]))
      }), 128))
    ], 2),
    (_ctx.useMessagePanel)
      ? (_openBlock(), _createBlock("section", _hoisted_25, [
          _createVNode(_component_MSMessagePanel)
        ]))
      : _createCommentVNode("", true)
  ]))
})